// The application backdrop uses the warmer orange and cooler blue tones from
// the Home experience. Keeping it in one place prevents individual pages from
// slowly drifting into slightly different shades of grey or lavender.
export const APP_BACKGROUND = [
  'radial-gradient(72% 68% at 9% -14%, rgba(252, 171, 106, 0.48), transparent 66%)',
  'radial-gradient(62% 72% at 101% 1%, rgba(85, 125, 214, 0.34), transparent 64%)',
  'radial-gradient(78% 76% at 96% 108%, rgba(255, 186, 125, 0.32), transparent 66%)',
  'radial-gradient(66% 70% at -8% 101%, rgba(144, 179, 240, 0.30), transparent 66%)',
  'linear-gradient(135deg, #F1EEF7 0%, #FFF7F0 52%, #EEF2FC 100%)',
].join(', ')
